import React, { useState } from 'react'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
import Button from '../Button'
import Collapse from '../Collapse'
import { FilterChipGroup } from '../NewFilterChip'
import { useTranslation } from '../../providers/TranslationProvider'
import type { DropdownSelectOption } from './DropdownSelect'

const useStyles = makeStyles((theme: Theme) => ({
  margin: {
    marginTop: theme.spacing(1.5)
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.paintscout.palette.brand.Neutral.P60,
    fontWeight: 500,
    padding: 0
  },
  chipGroup: {
    gridTemplateColumns: `repeat(auto-fill, minmax(120px, 1fr))`
  }
}))

interface DropdownChipsProps {
  options: DropdownSelectOption[]
  handleDelete: (option: DropdownSelectOption) => void
  autoOpen?: boolean
}

export default function DropdownChips({ options, handleDelete, autoOpen }: DropdownChipsProps) {
  const classes = useStyles()
  const { __ } = useTranslation()
  const [open, setOpen] = useState(!!autoOpen)
  return (
    <div className={classes.margin}>
      <Button
        variant="text"
        size="small"
        className={classes.button}
        icon={open ? ExpandLessIcon : ExpandMoreIcon}
        flipIconSide
        iconSize="large"
        onClick={() => setOpen(!open)}
      >
        {open ? __('Show Less') : __('Show More')}
      </Button>
      <Collapse show={open}>
        <div className={classes.margin}>
          <FilterChipGroup
            classes={{ root: classes.chipGroup }}
            chips={options.map((option) => ({
              label: option.label,
              value: option.value,
              onDelete: () => handleDelete(option)
            }))}
          />
        </div>
      </Collapse>
    </div>
  )
}
